module.exports = __webpack_public_path__ + "img/1.b01658b4.jpeg";